import ConditionLevelsTable from './ConditionLevelsTable';

export default ConditionLevelsTable;
export { ConditionLevelsTable };
